import React, { useState } from 'react';
import '../Style/FloatingContact.css';
import mailIcon from '../icons/mail-icon.png';

const COE_EMAIL = 'go-fmafricaprivateen@kpmg.com';

function FloatingContact() {
  const [tooltip, setTooltip] = useState(false);

  const handleClick = () => {
    const subject = encodeURIComponent('Enquiry – KPMG Africa Centre of Excellence');
    const body = encodeURIComponent(
      'Hello KPMG Africa CoE Team,\n\nI would like to inquire about:\n\n[Please describe your enquiry here]\n\nKind regards,'
    );
    window.location.href = `mailto:${COE_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="floating-contact">
      {tooltip && (
        <div className="floating-contact-tooltip">
          Contact Us via Email
        </div>
      )}
      <button
        className="floating-contact-btn"
        onClick={handleClick}
        onMouseEnter={() => setTooltip(true)}
        onMouseLeave={() => setTooltip(false)}
        aria-label="Contact us via email"
        title="Contact us via email"
      >
        <img src={mailIcon} alt="Email" className="floating-contact-icon" />
      </button>
    </div>
  );
}

export default FloatingContact;
